import React from 'react';
import { Link } from 'react-router-dom';
import { Movie } from '../types/api';

export const MovieCard: React.FC<{ movie: Movie }> = ({ movie }) => (
  <Link to={`/movies/${movie.id}`} className="group block overflow-hidden rounded-lg border border-stone-800 bg-black shadow-sm transition hover:border-[#ffd460] hover:shadow-md">
    <div className="aspect-[16/9] overflow-hidden bg-stone-900">
      <img src={movie.thumbnailUrl} alt={movie.title} className="h-full w-full object-cover transition duration-300 group-hover:scale-105" />
    </div>
    <div className="p-4">
      <div className="flex items-start justify-between gap-3">
        <h3 className="text-lg font-semibold text-white">{movie.title}</h3>
        <span className="shrink-0 rounded bg-[#ffd460] px-2 py-1 text-sm font-semibold text-stone-950">${Number(movie.price).toFixed(2)}</span>
      </div>
      <p className="mt-2 max-h-10 overflow-hidden text-sm text-stone-300">{movie.description}</p>
      <div className="mt-4 flex flex-wrap gap-2 text-xs font-medium text-stone-300">
        <span className="rounded border border-stone-700 bg-stone-900 px-2 py-1">{movie.language}</span>
        <span className="rounded border border-stone-700 bg-stone-900 px-2 py-1">{movie.genre}</span>
        <span className="rounded border border-stone-700 bg-stone-900 px-2 py-1">{movie.country}</span>
      </div>
    </div>
  </Link>
);
